import {
  INutritionalValue,
  WebProductPageLayout,
  PrismicWebProductPageLayoutContent,
} from '@monofront/types';
import React, { createContext } from 'react';
import { useHandlePrismicAbTests } from '../hooks/useHandlePrismicAbTests';

interface IProductLayoutProviderProps {
  productLayout: PrismicWebProductPageLayoutContent;
  nutritionalValues: INutritionalValue[];
  children: React.ReactNode;
}

type ProductLayoutContextValue = {
  productLayout: WebProductPageLayout;
  nutritionalValues: INutritionalValue[];
};

const ProductLayoutContext = createContext<ProductLayoutContextValue>({
  productLayout: {
    section_ordering: [
      {
        section_id: 'presentation',
        condition: null,
        label_menu: null,
        title: null,
      },
      {
        section_id: 'cocreation',
        condition: null,
        label_menu: null,
        title: null,
      },
      {
        section_id: 'advices',
        condition: null,
        label_menu: null,
        title: null,
      },
      {
        section_id: 'vendor',
        condition: null,
        label_menu: null,
        title: null,
      },
      {
        section_id: 'reviews',
        condition: null,
        label_menu: null,
        title: null,
      },
    ],
    reinsurance: [],
    reinsurance_background_color: null,
    reviews_description: null,
    slices_before_desc: 0,
    slices: [],
  },
  nutritionalValues: [],
});

const ProductLayoutProvider: React.FC<IProductLayoutProviderProps> = ({
  children,
  productLayout,
  nutritionalValues,
}) => {
  const productLayoutContent = useHandlePrismicAbTests(productLayout)!;

  return (
    <ProductLayoutContext.Provider
      value={{
        productLayout: productLayoutContent,
        nutritionalValues,
      }}
    >
      {children}
    </ProductLayoutContext.Provider>
  );
};

export { ProductLayoutContext, ProductLayoutProvider };
